import React from 'react';
import styled from 'styled-components';
import theme from '../../../theme';
import SubtitlesDemo from './SubtitlesDemo';
import mac from '../../../assets/mac-desktop.svg';
import macDownload from '../../../assets/mac-light-gray.svg';
import windowsDownload from '../../../assets/windows-light-gray.svg';
import DownloadButton from '../../../containers/Buttons/DownloadButton';
import TryItButton from '../../../containers/Buttons/TryItButton';
import { isDesktop } from '../../../utils';

const HeroContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  @media (max-width: ${theme.smallScreenCutoff}) {
    flex-wrap: wrap;
    flex-direction: column;
    padding: 40px 0 0 0;
  }
`;

const TextContainer = styled.div`
  min-width: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media (max-width: ${theme.smallScreenCutoff}) {
    min-width: none;
    max-width: 300px;
    margin-top: 40px;
  }
`;

const Text = styled.div`
  width: 100%; /* because IE doesn't wrap text https://stackoverflow.com/a/36574502 */
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  @media (max-width: ${theme.smallScreenCutoff}) {
    align-items: center;
    justify-content: center;
    text-align: center;
  }
`;

const Title = styled.h1`
  width: 100%; /* because IE doesn't wrap text https://stackoverflow.com/a/36574502 */
  color: ${theme.darkGray3};
  margin-bottom: 20px;
`;

const Description = styled.p`
  width: 100%; /* because IE doesn't wrap text https://stackoverflow.com/a/36574502 */
  color: ${theme.gray1};
  margin-bottom: 40px;
`;

const DemoContainer = styled.div`
  padding-bottom: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transform: scale(0.8);
  width: 100%;
  @media (min-width: ${theme.verySmallScreenCutoff}) and (max-width: ${theme.smallScreenCutoff}) {
      transform: scale(0.5);
  }
  @media (max-width: ${theme.verySmallScreenCutoff}) {
      transform: scale(0.4);
  }
`;

const Subtitles = styled.div`
  transform: translateY(200px);
  height: 0;
`;


const Helper = styled.div`
  width: 100%;
  color: ${theme.gray3};
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const MacDownload = styled.div`
  margin-left: 10px;
`;

const WindowsDownload = styled.div`
  margin-top: 3px;
  margin-left: 10px;
  margin-right: 5px;
`;

const Image = styled.div`
 
  /* image */
  background-image: url(${props => props.src});
  
  /* make a square container */
  height: 16px;
  width: 16px;
  
  /* size: cover / contain */
  background-size: 100% 100%;

  /* center the image vertically and horizontally */
  background-position: center;
`;

const button = isDesktop() ? (
    <div>
      <DownloadButton text="DOWNLOAD"/>
      <Helper>
        <div>Available for</div>
        <MacDownload>
          <Image src={macDownload}/>
        </MacDownload>
        <WindowsDownload>
          <Image src={windowsDownload}/>
        </WindowsDownload>
      </Helper>
    </div>
  ) : <TryItButton/>;


class Hero extends React.Component {

  state = {imageLoaded: false};

  handleImageLoaded = () => {
    this.setState({imageLoaded: true})
  };

  render() {

    const subtitlesDemo = this.state.imageLoaded ? (
        <Subtitles>
          <SubtitlesDemo/>
        </Subtitles>
      ) : null;

    const macScreen = <img
      src={mac} alt="Live Subtitles Demo"
      onLoad={this.handleImageLoaded}
    />;

    return (
      <HeroContainer>
        <TextContainer>
          <Text>
            <Title>Live subtitles in any language</Title>
            <Description>
              Convert speech from your speakers into live subtitles.
              And get the translation on the fly.
            </Description>
            <div>
              {button}
            </div>
          </Text>
        </TextContainer>
        <DemoContainer>
          {subtitlesDemo}
          {macScreen}
        </DemoContainer>
      </HeroContainer>
    )
  }
}

export default Hero;



// WEBPACK FOOTER //
// ./src/components/PublicWebsite/Hero/index.js